import script from "./NotFoundView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundView.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundView.vue?vue&type=style&index=0&id=45cdc252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cdc252"]])

export default __exports__